import React, { useEffect, useState } from "react";
import assetsCompareServices from "./assetsCompareServices";
import korrectLogo from '../../../assets/images/korrectLogoIcon.png';
import adminLogo from '../../../assets/images/logo.png';
import Pagination from "../../Header/Pagination";
import { Filter } from "filter";
import { format } from "date-fns";
import PeriodSelectionForm from "components/PeriodSelection/periodSelectionForm";
import cachingMechanisum from "components/Common/cachingMechanisum";

export default function TrendCompare() {
    let [totalRows, setTotalRows] = useState(0);
    let [searchFor, setsearchFor] = useState("");
    let [AssetType, setAssetType] = useState("OnkorrectOnly");
    let [TrendType, setTrendType] = useState("ContractTrend");
    let [fullAdminAssets, setFullAdminAssets] = useState<any>([]);
    let [reportingTo, setreportingTo] = useState("");
    let [reportingFrom, setreportingFrom] = useState("");
    let [periodSelection, setperiodSelection] = useState(false);
    let [fullTempAdminAssets, setFullTempAdminAssets] = useState<any>([]);
    let [periodSelected, SetperiodSelected] = useState<any>([]);
    let [Listing_Type, setListing_Type] = useState("Summary");

    var payload = {
        method: AssetType,
        "PerFrom": reportingFrom,
        "PerTo": reportingTo,
        pageNumber: 1,
        pageSize: 10,
        trendType: TrendType,
        ExportType: "",
        ExportFor: "Portal"
    }

    useEffect(() => {
        searchFor = "";
        setsearchFor(searchFor);

        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");
        console.log(periodListCache)
        for (var i = 0; i < periodListCache.length; i++) {
            if (periodListCache[i].periodCurrent === 1) {
                periodSelected = periodListCache[i]
                SetperiodSelected(periodSelected)
            }
        }


        reportingFrom = String(Filter.DateTimeFormatNumber(periodSelected?.periodFrom));
        reportingTo = String(Filter.DateTimeFormatNumber(periodSelected?.periodTo));

        setreportingFrom(String(Filter.DateTimeFormatNumber(periodSelected?.periodFrom)));
        setreportingTo(String(Filter.DateTimeFormatNumber(periodSelected?.periodTo)));

        console.log(typeof (reportingFrom))
        console.log(reportingTo)


        if (reportingFrom === "[object Object]") {
            reportingFrom = "20200131"
            setreportingFrom(reportingFrom)
        }

        if (reportingTo === "[object Object]") {
            reportingTo = "20290131"
            setreportingTo(reportingTo)
        }
        console.log(reportingFrom)
        console.log(reportingTo)
    }, [])

    const searchSummary = (e: any) => {
        payload.method = AssetType
        assetsCompareServices.trendCompare(payload).then((res) => {
            fullTempAdminAssets = res
            setFullTempAdminAssets(fullTempAdminAssets)
            totalRows = res?.length
            setTotalRows(totalRows)
            setFullAdminAssets((fullTempAdminAssets?.slice((payload.pageNumber - 1) * payload.pageSize, (payload.pageSize * payload.pageNumber))))
        })
    }

    const paginationHandler = (e: any) => {
        payload.pageNumber = e.pageNumber;
        payload.pageSize = e.pageSize;
        setFullAdminAssets((fullTempAdminAssets?.slice((e.pageNumber - 1) * e.pageSize, (e.pageSize * e.pageNumber))))
    }

    const searchForSummary = (e: any) => {
        console.log(searchFor)

        if (fullTempAdminAssets.length > 0) {

            if (searchFor.length > 0) {

                var obj = fullTempAdminAssets.filter((item: any) => {
                    return (
                        item?.portalTrendBO?.customId?.toLowerCase().includes(searchFor.toLowerCase()) ||
                        item?.portalTrendBO?.provider?.toLowerCase().includes(searchFor.toLowerCase()) ||
                        item?.portalTrendBO?.month?.toLowerCase().includes(searchFor.toLowerCase()) ||

                        item?.korrectTrendBO?.customId?.toLowerCase().includes(searchFor.toLowerCase()) ||
                        item?.korrectTrendBO?.dsp?.toLowerCase().includes(searchFor.toLowerCase()) ||
                        item?.korrectTrendBO?.period?.toLowerCase().includes(searchFor.toLowerCase())
                    );
                });

                totalRows = obj?.length
                setTotalRows(totalRows)

                setFullAdminAssets(obj)
            } else {

                setFullAdminAssets((fullTempAdminAssets?.slice((payload.pageNumber - 1) * payload.pageSize, (payload.pageSize * payload.pageNumber))))
            }
        } else {
            searchSummary("all")
        }

    }

    const onChangePeriod = (period: any) => {

        if (period.periodFrom) {
            payload.PerFrom = period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd');
            reportingFrom = period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd');
            setreportingFrom(period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd'));
            payload.PerFrom = reportingFrom;
        }

        if (period.periodTo) {
            payload.PerTo = period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd');
            reportingTo = period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd');
            setreportingTo(period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd'));
            payload.PerTo = reportingTo;
        }

        if (period && period.action && period.action === 2) {
            searchSummary("");
        }
    }

    const closePeriod = (e: any) => {
        console.log(e)
        periodSelection = false;
        setperiodSelection(false)

        console.log(payload)
    }

    const TrendCompareExport = () => {
        payload.PerFrom = reportingFrom;
        payload.PerTo = reportingTo;
        payload.method = AssetType
        payload.ExportType = "trendCompareExport"
        assetsCompareServices.trendCompareExport(payload);
    }

    const trendComparedDetail = () => {
        payload.PerFrom = reportingFrom;
        payload.PerTo = reportingTo;
        payload.method = AssetType
        payload.ExportType = "trendCompareExport";

        assetsCompareServices.trendCompareDetail(payload)
    }


    return (<>
        <div className="landing ws-12">

            <div className="ws-12 pLarge">
                <div className="ws-12 ptxl mtl">
                    <span className="ws-12 text-bold text-xl">Asset Management</span>
                    <span className="ws-12 ptl text-bold text-m turquoise">Trend Compare</span>
                </div>

                <div className='ws-12'>
                    <ul className="nav nav-tabs p0 m0 pull-right">
                        <li className={TrendType === "ContractTrend" ? " white m0 bg-level7" : "m0"} onClick={() => { TrendType = 'ContractTrend'; setTrendType(TrendType); }}>Contract Trend</li>
                        <li className={TrendType === "AssetTrend" ? "white m0 bg-level7 hide" : "m0 hide"} onClick={() => { TrendType = 'AssetTrend'; setTrendType(TrendType); }}>Asset Trend</li>
                    </ul>
                </div>

                <div className='ws-12 mtl'>
                    <ul className="nav nav-tabs p0 m0 pull-right">
                        <li className={AssetType === "OnkorrectOnly" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => { AssetType = 'OnkorrectOnly'; setAssetType(AssetType); searchSummary(searchFor) }}>On korrect Only</li>
                        <li className={AssetType === "OnPortalOnly" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => { AssetType = 'OnPortalOnly'; setAssetType(AssetType); searchSummary(searchFor) }}>On Portal Only</li>
                        <li className={AssetType === "Unmatched" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => { AssetType = 'Unmatched'; setAssetType(AssetType); searchSummary(searchFor) }}>Different Value</li>
                        <li className={AssetType === "Simmilar" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => { AssetType = 'Simmilar'; setAssetType(AssetType); searchSummary(searchFor) }}>Similar</li>
                    </ul>

                    <div className="ws-12 ptl">
                        <span className="text-bold text-m">Showing <span className="info">{totalRows}</span> results</span>
                        <button className="icon-btn edit pull-right pm" onClick={TrendCompareExport}>Export For Portal</button>

                        <div className="pull-right mrl ">
                            <div className="ws-12">
                                <div className="centerWindow ws-12">
                                    <a className="icon-btn edit pm ws-12" onClick={() => setperiodSelection(true)}>
                                        <i className="icon-angle-right text-m pull-right mll"></i>
                                        <span className="pull-right success"> {Filter.NumToDate(reportingTo)}</span>
                                        <i className="icon-vertical-line ml pull-right mr text-sl success"></i>
                                        <span className="pull-right success">{Filter.NumToDate(reportingFrom)}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {AssetType === "OnkorrectOnly" && <div className='ws-12 ptl'>
                    <ul className="nav nav-tabs p0 m0 pull-right">
                        <li className={Listing_Type === "Detail" ? " white m0 bg-level7" : "m0 mr"} onClick={() => { Listing_Type = 'Detail'; setListing_Type(Listing_Type); trendComparedDetail(); }}>Detail</li>
                        <li className={Listing_Type === "Summary" ? "white m0 bg-level7" : "m0 mr"} onClick={() => { Listing_Type = 'Summary'; setListing_Type(Listing_Type); searchSummary(""); }}>Summary</li>
                    </ul>
                </div>}

                {<div className="ws-12 ptxl">

                    <div className="ws-12 mbl">
                        <button className="btn white pLarge bg-level14 m0 ws-2" onClick={() => searchForSummary(searchFor)}> Search</button>
                        <input type="text" value={searchFor} onChange={(e) => setsearchFor(e.target.value)} className="pLarge ws-10 m0 heightReset" placeholder="Type to search" />
                    </div>

                </div>}

                {fullAdminAssets?.length > 0 && (AssetType === "OnPortalOnly") && <div className='ws-12 mtl pLarge tableVertical'>
                    <table className={'tableVertical ws-12'}>
                        <thead>
                            <tr>
                                <th className="text-center">CustomId</th>
                                <th className="text-center">DSP Name</th>
                                <th className="text-center">Period</th>
                                <th className="text-center">Value</th>
                            </tr>
                        </thead>
                        <tbody>

                            {
                                fullAdminAssets?.map((value: any) => {
                                    return (

                                        <>
                                            {(!value?.korrectTrendBO) && <tr style={{ border: "1px solid #000000" }}>
                                                <td width='24%' className="mt">
                                                    <span className="ws-12 mt">{value?.portalTrendBO?.customId}</span>
                                                </td>
                                                <td width='24%'>
                                                    <span className="ws-12 mt">{value?.portalTrendBO?.provider}</span>
                                                </td>
                                                <td width='24%'>
                                                    <span className="ws-12 mt">{value?.portalTrendBO?.month}</span>
                                                </td>
                                                <td width='24%'>
                                                    <span className="ws-12 mt">{value?.portalTrendBO?.total_net_payout}</span>
                                                </td>
                                            </tr>}
                                        </>
                                    )
                                })
                            }

                        </tbody>

                    </table>
                </div>}

                {fullAdminAssets?.length > 0 && (AssetType === "OnkorrectOnly") && (Listing_Type === "Summary") && <div className='ws-12 mtl pLarge tableVertical'>
                    <table className={'tableVertical ws-12'}>
                        <thead>
                            <tr>
                                <th className="text-center">CustomId</th>
                                <th className="text-center">DSP Name</th>
                                <th className="text-center">Period</th>
                                <th className="text-center">Value</th>
                            </tr>
                        </thead>
                        <tbody>

                            {
                                fullAdminAssets?.map((value: any) => {
                                    return (

                                        <>
                                            {(!value?.portalTrendBO) && <tr style={{ border: "1px solid #000000" }}>
                                                <td width='24%' className="mt">
                                                    <span className="ws-12 mt">{value?.korrectTrendBO?.customId}</span>
                                                </td>
                                                <td width='24%'>
                                                    <span className="ws-12 mt">{value?.korrectTrendBO?.dsp}</span>
                                                </td>
                                                <td width='24%'>
                                                    <span className="ws-12 mt">{value?.korrectTrendBO?.period}</span>
                                                </td>
                                                <td width='24%'>
                                                    <span className="ws-12 mt">{value?.korrectTrendBO?.value}</span>
                                                </td>
                                            </tr>}
                                        </>
                                    )
                                })
                            }

                        </tbody>

                    </table>
                </div>}

                {fullAdminAssets?.length > 0 && (AssetType === "Simmilar" || AssetType === "Unmatched") && <div className='ws-12 mtl pLarge tableVertical'>
                    <table className={'tableVertical ws-12'}>
                        <thead>
                            <tr>
                                <th className="text-center"> </th>
                                <th className="text-center">CustomId</th>
                                <th className="text-center">DSP Name</th>
                                <th className="text-center">Period</th>
                                <th className="text-center">Value</th>
                            </tr>
                        </thead>
                        <tbody>

                            {
                                fullAdminAssets?.map((value: any) => {
                                    return (
                                        <tr style={{ border: "1px solid #000000" }}>
                                            <td>
                                                <span className="ws-12 mt">
                                                    <img alt="Korrect"  src={korrectLogo} height={35} style={{ borderRadius: "4px" }} />

                                                </span>
                                                <span className="ws-12 mt text-">
                                                    <img alt="Korrect"  src={adminLogo} height={35} style={{ border: "1px solid #bfbfbf", borderRadius: "4px" }} />
                                                </span>

                                            </td>

                                            <td width='23%' className={!value?.korrectTrendBO?.customId || !value?.portalTrendBO?.customId ? 'bg-level6 mt' : 'mt'}>
                                                <span className="ws-12 mt" style={{ height: "40px" }}>{value?.korrectTrendBO?.customId}</span>
                                                <span className="ws-12 mt">{value?.portalTrendBO?.customId}</span>
                                            </td>
                                            <td width='23%' className={!value?.korrectTrendBO?.dsp || !value?.portalTrendBO?.provider ? 'bg-level6 mt' : 'mt'}>
                                                <span className="ws-12" style={{ height: "40px" }}>{value?.korrectTrendBO?.dsp}</span>
                                                <span className="ws-12 mt">{value?.portalTrendBO?.provider}</span>
                                            </td>
                                            <td width='23%' className={!value?.korrectTrendBO?.period || !value?.portalTrendBO?.month ? 'bg-level6 mt' : 'mt'}>
                                                <span className="ws-12 mt" style={{ height: "40px" }}>{value?.korrectTrendBO?.period}</span>
                                                <span className="ws-12 mt">{value?.portalTrendBO?.month}</span>
                                            </td>
                                            <td width='23%' className={(value?.korrectTrendBO?.value !== value?.portalTrendBO?.total_net_payout) ? 'bg-level6 mt' : 'mt'}>
                                                <span className="ws-12 mt" style={{ height: "40px" }}>{value?.korrectTrendBO?.value}</span>
                                                <span className="ws-12 mt">{value?.portalTrendBO?.total_net_payout}</span>
                                            </td>
                                        </tr>
                                    )
                                })
                            }

                        </tbody>

                    </table>
                </div>}

                {(totalRows > 0) && <div className="clearfix ws-12 pm">
                    {(() => {
                        if (totalRows && totalRows > 10) {
                            return  <Pagination onPageChange={paginationHandler} totalRow={totalRows} />
                        }
                    })()}
                </div>}
            </div>

            {(() => {
                if (periodSelection === true) {
                    return <PeriodSelectionForm open={periodSelection} closePeriod={closePeriod} onChange={onChangePeriod} periodFrom={Filter.convertToDateString(reportingFrom)} periodTo={Filter.convertToDateString(reportingTo)} />;
                }

            })()}
        </div>

    </>)
}